import { getField } from 'vuex-map-fields';

export default {
  merchantActivity: state => state.merchantActivity,
  sentMessageStatus: state => state.sentMessageStatus,
  newMessageConversation: state => state.newMessageConversation,
  newConversationActivity: state => state.newConversationActivity,
  echoConnectionLost: state => state.echoConnectionLost,
  getField,
  importStats: state => state.importStats,
  importRunning: state => state.importRunning,
  preventImportToastMessage: state => state.preventImportToastMessage,
  bulkSendProgress: state => state.bulkSendProgress,
  bulkMessageRunningState: state => state.bulkMessageRunningState,
  exportStats: state => state.exportStats,
  exportRunning: state => state.exportRunning,
  conversationActivity: state => state.conversationActivity,
  readUpdate: state => state.readUpdate,
  pusherTooOld: state => state.pusherTooOld,
  lastMessageTime: state => state.lastMessageTime,
  reconnectChannel: state => state.reconnectChannel,
  businessAvailabilityChange: state => state.businessAvailabilityChange,
  newRoute: state => state.newRoute,
};
